export default __webpack_public_path__ + "static/media/slider4.182dd8e1.jpg";